import React from 'react'
import Layout from '../../components/Layout';
export default function CoachingChat() {
  return (
    <Layout>
    <div>CoachingChat</div>
    </Layout>
  )
}
